<div class="backdrop" [ngStyle]="{'display': price_hierarchy_pop_up_settings.open}"></div>
<div *ngIf="price_hierarchy_pop_up_settings.open == 'block'" class="modal price_hierarchy" tabindex="-1" role="dialog" [ngStyle]="{'display':price_hierarchy_pop_up_settings.open}">
    <!-- modal-dialog -->
    <div class="modal-dialog modal-dialog-centered" role="document">
        <!-- modal-content -->
        <div class="modal-content">
            <!-- modal-header -->
            <div class="modal-header">
                <h4 class="modal-title header_label_portal text-black mt-1 costa_text">
                    {{"lang.scenerio.reset_price_heirarchy" | translate}}
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="closePopup()"><span
                        aria-hidden="true">&times;</span></button>
            </div>

            <!-- modal-body -->
            <div class="modal-body cancelBody">
                <div class="new-pricing">
                   <table mat-table [dataSource]="price_hierarchy_dataSource" *ngIf="price_hierarchy_data.length>0">
                        <ng-container matColumnDef="priceBand">
                            <th  mat-header-cell *matHeaderCellDef>Price Band</th>
                            <td mat-cell *matCellDef="let row">{{row.geo_name |titlecase }}</td>
                        </ng-container>
                        <ng-container matColumnDef="food">
                            <th  mat-header-cell *matHeaderCellDef>Food</th>
                            <td mat-cell class="price" *matCellDef="let row">
                                <input *ngIf="!(row?.is_base_pb) && row.Food" type="text" class="form-control instore-price" [(ngModel)]="row.Food.value"  appTwoDigitDecimalNumber [disabled]="!category_error || (category_ids.length>0 && !category_ids.includes(row?.Food?.sku02))" [ngClass]="{'input_disable': !category_error || (category_ids.length>0 && !category_ids.includes(row?.Food?.sku02))}"
                                (keypress)="onlyNumberKey($event)"
                                (keyup)="onValidatePercentageChange(row?.Food?.originalValue ,row?.geo_code+':'+row?.Food?.sku02 ,$event)">
                                <span *ngIf="row?.is_base_pb && row.Food" class="highlight_text">{{row?.Food?.value}}</span>
                                <span *ngIf="row.Food">%</span>
                                <span *ngIf="!row.Food">-</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="beverages">
                            <th  mat-header-cell *matHeaderCellDef>Beverages</th>
                            <td  mat-cell class="price" *matCellDef="let row">
                                <input *ngIf="!(row?.is_base_pb) && row.Beverages"  type="text" class="form-control instore-price" [(ngModel)]="row.Beverages.value"  appTwoDigitDecimalNumber [disabled]="!category_error || (category_ids.length>0 && !category_ids.includes(row?.Beverages?.sku02))" [ngClass]="{'input_disable': !category_error || (category_ids.length>0 &&  !category_ids.includes(row?.Beverages?.sku02))}"
                                (keypress)="onlyNumberKey($event)"
                                (keyup)="onValidatePercentageChange(row?.Beverages?.originalValue,row?.geo_code+':'+row?.Beverages?.sku02,$event)">
                                <span *ngIf="row?.is_base_pb && row.Beverages" class="highlight_text">{{row?.Beverages?.value}}</span>
                                <span *ngIf="row.Beverages">%</span>
                                <span *ngIf="!row.Beverages">-</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="fmgc">
                            <th  mat-header-cell *matHeaderCellDef>FMCG</th>
                            <td mat-cell class="price" *matCellDef="let row">
                                <input *ngIf="!(row.is_base_pb)"  type="text" class="form-control instore-price" [(ngModel)]="row.fmgc.percentage"  appTwoDigitDecimalNumber
                                (keypress)="onlyNumberKey($event)"
                                (focusout)="onValidatePercentageChange(row.fmgc.originalValue ,row.geo_code+':'+row.fmgc.sku02,$event)">
                                <span *ngIf="row.is_base_pb" class="highlight_text">{{row.fmgc.percentage}}</span>
                                <span>%</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="price_hierarchy_table_columns;"></tr>
                        <tr [ngClass]="row.is_base_pb ? 'highlight' : ''"  mat-row *matRowDef="let row; columns: price_hierarchy_table_columns;"></tr>
                   </table>
                </div>
            </div>
            <!-- modal-footer -->
            <div class="modal-footer" *ngIf="category_error">
                <div class="category_error">
                    {{error_message}}
                </div>
                <button type="button" class="cancel-btn btn btn-default table-submit button_portal mr-3"
                    (click)="closePopup()">{{'lang.common.no' | translate}}
                </button>
                <button class="settings-btn btn btn-default table-submit button_portal save-confrim-button"
                    (click)="savePriceHeirarchyDetails()" [disabled] ="is_validate_percentage_enable" [ngClass]="{disable_save:is_validate_percentage_enable}" type="button">{{'lang.common.yes' | translate}}
                </button>
            </div>
            <div class="category_error" *ngIf="!category_error">
                {{error_message}}
            </div>
        </div>
    </div>
</div>
